import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import request from "./common/request";
import ElementUI from "element-ui";
import VueI18n from "vue-i18n";
import enLocale from "element-ui/lib/locale/lang/en";
import cnLocale from "element-ui/lib/locale/lang/zh-CN";
import twLocale from "element-ui/lib/locale/lang/zh-TW";
import jaLocale from "element-ui/lib/locale/lang/ja";
import axios from "axios";
import qs from "qs";
import onlineUser from "./common/OnlineUser";
import commonUtils from "./common/CommonUtils";
import dataStorage from "./common/DataStorage";
import JSEncrypt from "jsencrypt";
import md5 from "js-md5";
import BigNumber from "bignumber.js";
import "font-awesome/css/font-awesome.css";
import "./skin/element-ui-style/index.css";
import "./assets/icon/iconfont.css";
import "@/assets/css/cover.less"
import VueCoreVideoPlayer from "vue-core-video-player";
import codeTableMixin from '@/mixins/codeTableMixin'

// 代码表
Vue.mixin(codeTableMixin)

import { MessageBox } from "element-ui";
Vue.prototype.$Big = BigNumber;
//下载url
Vue.prototype.$downloadFileUrl = function(uri) {
  return process.env.API_ROOT + "/mes/system/file/download/" + uri;
};
Vue.use(VueCoreVideoPlayer, { lang: "zh-CN" });
import VideoTimeline from "@wanglin1994/video-timeline";
Vue.use(VideoTimeline);

import { loadDirectives } from "./common/directives";
import "@/common/common.less";
Vue.use(loadDirectives);

import QRcode from "./components/warehouse/produceOrderIn/QRcode";
Vue.use(QRcode);

import VXETable from "vxe-table";
import "vxe-table/lib/style.css";
VXETable.setConfig({ size: "mini" });
Vue.use(VXETable);

Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.prototype.onlineUser = onlineUser;
Vue.prototype.$common = commonUtils;
Vue.prototype.$s = dataStorage;
// 添加自定义请求
Vue.use(request)

Vue.prototype.$fileUrl = function(uri) {
  return process.env.FILE_ROOT + "/mesfiles/" + uri;
};

if (!localStorage.lang) {
  localStorage.setItem("lang", "zh_CN");
}

const i18n = new VueI18n({
  locale: localStorage.lang || "zh_CN",
  messages: {
    zh_CN: Object.assign(require("./common/lang/cn"), cnLocale),
    en_US: Object.assign(require("./common/lang/en"), enLocale),
    zh_TW: Object.assign(require("./common/lang/tw"), twLocale),
    ja_JP: Object.assign(require("./common/lang/ja"), jaLocale)
  }
});

router.beforeEach((to, from, next) => {
  let onlineUser = Vue.prototype.onlineUser;
  if (to.meta.requiresAuth) {
    if (!onlineUser.getUser()) {
      next({ path: "/login" });
    } else {
      if (
        to.meta.permission &&
        !onlineUser.checkPermission(to.meta.permission)
      ) {
        next({ path: "/403" });
      } else if (
        to.meta.permissions &&
        !onlineUser.checkAnyPermission(to.meta.permissions)
      ) {
        next({ path: "/403" });
      } else {
        next();
      }
    }
  } else {
    next();
  }
  let flage = localStorage.getItem("deviceNetworking");

  if (
    to.fullPath == "/forms/iot/deviceNetworking" &&
    flage == "0" &&
    to.fullPath != "/forms/iot/deviceNetworking?data=1"
  ) {
    // console.log(MessageBox,createElement,'h')
    new Vue({
      render(h) {
        // 使用 $createElement 创建虚拟 DOM
      },
      data: {
        selectedProcess: ""
      },
      mounted() {
        const h = this.$createElement;

        // 调用 MessageBox，并传入自定义的内容
        MessageBox({
          title: "消息",
          message: h("div", null, [
            h("p", null, "请选择一个选项："),
            h(
              "select",
              {
                ref: "select",
                on: {
                  change: event => {
                    this.selectedProcess = event.target.value; // 更新选中的值
                  }
                },
                style: "width: 50%;height: 30px;"
              },
              [
                h("option", { value: "option1" }, ""),
                h("option", { value: "option2" }, "注塑"),
                h("option", { value: "option3" }, "冲压")
              ]
            )
          ]),
          showCancelButton: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              // 获取下拉框的选中值
              const selectValue = this.selectedProcess;
              // 根据选中值执行相应操作
              if (selectValue) {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "执行中...";

                done();
                instance.confirmButtonLoading = false;
                localStorage.setItem("deviceNetworking", selectValue);
                localStorage.setItem("selectValue", selectValue);
                localStorage.setItem("selectValueItem", "1");
                location.reload();
              } else {
                // 如果没有选择，则不关闭对话框，并给出提示
                Message({
                  type: "warning",
                  message: "请选择一个选项后再确定！"
                });
                done(false); // 阻止对话框关闭
              }
            } else {
              // 如果用户点击取消，则直接关闭对话框
              done();
              next({ path: "/" });
              location.reload();
            }
          }
        }).then(action => {
          // 这里 action 的值将是 'confirm' 或 'cancel'
          // 但由于我们在 beforeClose 中已经处理了逻辑，所以这里不需要再做额外处理
        });
      }
    }).$mount("#app");
  } else {
    localStorage.setItem("deviceNetworking", "0");
  }
});

Vue.directive("debounce", {
  // 当被绑定的元素插入到 DOM 中时
  inserted(el, binding) {
    // 获取防抖时间和立即执行参数
    const wait = binding.arg || 300; // 默认防抖时间为 300ms
    const immediate = binding.modifiers.immediate || false;

    // 创建防抖函数
    const debouncedFunction = commonUtils.debounce(
      binding.value,
      wait,
      immediate
    );

    // 绑定事件
    el.addEventListener("input", debouncedFunction);

    // 清理事件监听器
    el._debouncedFunction = debouncedFunction; // 保存引用以便在 unbind 中使用
  },
  // 当指令与元素解绑时
  unbind(el) {
    el.removeEventListener("input", el._debouncedFunction);
    delete el._debouncedFunction; // 清理引用
  }
});
// 在 main.js 或全局工具文件中注册
Vue.prototype.$download = function(url, data, filenameFunc) {
  const t = this;
  // 复用原逻辑：添加语言参数和 Token
  const params = { ...data, lang: localStorage.lang || "zh_CN" };
  const headers = {};
  if (onlineUser.getToken()) {
    headers["authorization"] = "Bearer " + onlineUser.getToken();
  }

  // 发送 POST 请求，指定响应类型为 blob（二进制流）
  return axios
    .post(process.env.API_ROOT + url, params, {
      headers: {
        ...headers,
        "Content-Type": "application/json" // 按 JSON 格式传递参数
      },
      responseType: "blob" // 关键：接收二进制文件流
    })
    .then(response => {
      // 复用 Token 刷新逻辑
      if (response.headers.authorization) {
        onlineUser.setToken(response.headers.authorization);
        console.log("刷新token");
      }

      // 处理响应：判断是否为文件流（可能后端错误时返回 JSON 文本）
      const contentType = response.headers["content-type"];
      if (contentType && contentType.includes("application/json")) {
        // 若返回 JSON 错误信息，转换为文本解析
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errorJson = JSON.parse(reader.result);
              reject(errorJson || { message: "下载失败" });
            } catch (e) {
              reject({ message: "下载响应格式错误" });
            }
          };
          reader.readAsText(response.data);
        });
      }

      // 生成文件下载链接
      const blob = new Blob([response.data], {
        type: contentType || "application/octet-stream"
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // 调用文件名处理函数获取文件名（允许动态生成）
      const fileName = filenameFunc ? filenameFunc() : "下载文件.xlsx";
      link.setAttribute("download", fileName);

      // 触发下载并清理资源
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return { success: true };
    })
    .catch(error => {
      console.error(error);
      t.$message({
        showClose: true,
        duration: 3000,
        message: t.$t("message.error_ajax"),
        type: "error"
      });
      func.call(Vue, { error: error.toString() });
    });
};
Vue.prototype.$post = function(url, data, func, met = "form") {
  let t = this;
  data["lang"] = localStorage.lang || "zh_CN";

  let headers = {};
  if (onlineUser.getToken()) {
    headers["authorization"] = "Bearer " + onlineUser.getToken();
  }
  var res = data;
  if (met == "form") {
    res = qs.stringify(data);
  }
  if (met == "image") {
    headers = {
      authorization: "Bearer " + onlineUser.getToken(),
      "Content-Type": "multipart/form-data" // 注意：通常不需要手动设置，axios会自动处理headers，但如果你需要自定义，可以这样做。通常不需要设置此头部，除非有特殊需求。
    };
    // res = qs.stringify(data);
  }
  axios
    .post(process.env.API_ROOT + url, res, { headers: headers })
    .then(response => {
      // 刷新Token
      if (response.headers.authorization) {
        onlineUser.setToken(response.headers.authorization);
        console.log("刷新token");
      }
      let json =
        typeof response.data === "object"
          ? response.data
          : JSON.parse(response.data);
      // 登录跳转
      if (json["LOGIN_VALIDATE"]) {
        this.$message({
          showClose: true,
          duration: 3000,
          message: this.$t("message.error_not_login"),
          type: "error"
        });
        sessionStorage.removeItem("MES_LOGIN_USER_BEAN");
        this.$router.push({ path: "/login" });
      }
      // 权限拦截提醒
      else if (json["PERMISSION_VALIDATE"]) {
        this.$message({
          showClose: true,
          duration: 3000,
          message: this.$t("message.error_permission_validate"),
          type: "error"
        });
        func.call(Vue, { error: this.$t("message.error_permission_validate") });
      }
      // 参数校验失败
      else if (json["PARAM_VALIDATE"]) {
        t.$message({
          showClose: true,
          duration: 3000,
          message: this.$t("message.error_param_validate"),
          type: "error"
        });
        func.call(Vue, { error: this.$t("message.error_permission_validate") });
      }
      // 超时
      else if (json["TIME_OUT"]) {
        this.$message({
          showClose: true,
          duration: 3000,
          message: this.$t("message.timeout"),
          type: "error"
        });
        func.call(Vue, { error: this.$t("message.timeout") });
      }
      // 调用
      else {
        if (func) {
          func.call(Vue, json);
        }
      }
    })
    .catch(error => {
      console.error(error);
      t.$message({
        showClose: true,
        duration: 3000,
        message: t.$t("message.error_ajax"),
        type: "error"
      });
      func.call(Vue, { error: error.toString() });
    });
};

// 不用POST，加密有问题
Vue.prototype.$get = function(url, data, func) {
  this.$post(url, data, func);
};

Vue.prototype.$scmPost = function(url, data, func) {
  let t = this;
  data["lang"] = localStorage.lang || "zh_CN";

  let headers = {};
  let timestamp = new Date().getTime() + "";
  {
    let Base64 = require("js-base64").Base64;
    let publicKey =
      "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAgBA3YjzmqABKAI0C9MtNb41ScSRDR8OU4O5z01W8jy/3iPy4BpRXRcWrvWp/eRSLVthOZtyxPXvoUTUr3e6Ju//Bp+0BjWtHbI7bs+sO+HSYf7FE3MzCVbiWsletPkdUW2vBIfWAi1SRYrbXsV7++haIt0aCfgLQzl2YKLOReL3e6gFJREDs6147nFvgb6F6bUSI1py2Cuim7pedlXikKRog0fEvC6gtQrdPVR4yR2L9+6xGBshOwZFVEGrAndEQ0K2Kj+yQyEW1Ia3wkPFKLBPMn68ao+Op2lXUEv4M22kCPf3Sm2tl3WXRaQSUnwhqftQ8RZWPLb/vc5eRQgs+5QIDAQAB";
    let encryptor = new JSEncrypt();
    encryptor.setPublicKey(publicKey);
    headers.client = encryptor.encrypt(md5.hex(Base64.encode(timestamp)));
    headers.timestamp = timestamp;
  }

  axios
    .post(process.env.API_ROOT + url, qs.stringify(data), { headers: headers })
    .then(response => {
      if (func) {
        func.call(Vue, response);
      }
    })
    .catch(error => {
      console.error(error);
      t.$message({
        showClose: true,
        duration: 3000,
        message: t.$t("message.error_ajax"),
        type: "error"
      });
      func.call(Vue, { error: error.toString() });
    });
};

Vue.use(ElementUI, { size: "mini", i18n: (key, value) => i18n.t(key, value) });

new Vue({
  el: "#app",
  i18n,
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js